const versionConfig = {
    version: 'v1.1.0',
    UDIDI: "00850031080225",
    UDIPI: '1.1.0',
    manufactureDate: '2026-10'
}

export default versionConfig
